import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown } from "rsuite";
import { Toaster, Message, Button } from "../index";
function DropdownButtons(props) {
    const { mainButtonIcon, placement, menuStyle, disabled, showMessages, dropdownButtons, header, footer, } = props;
    const toaster = Toaster();
    const pushMessage = (message, type = "info") => {
        toaster.push(_jsx(Message, { children: message, type: type, showIcon: true }), {
            duration: 4000,
            placement: "bottomEnd",
        });
    };
    const pushSuccess = (actionName) => pushMessage(`Action "${actionName}" dispatched successfully.`);
    const pushFailure = (actionName) => pushMessage(`Action "${actionName}" failed.`, "error");
    // shouldn't do this at this level
    const wrapAction = (action) => {
        const name = action.name;
        return async (...args) => {
            try {
                await action.action(...args);
                showMessages ?? pushSuccess(name);
            }
            catch (e) {
                showMessages ?? pushFailure(name);
                console.error(e);
            }
        };
    };
    const renderButton = (props, ref) => {
        return (_jsx(Button, { ...props, type: mainButtonIcon.type, className: mainButtonIcon.className, disabled: mainButtonIcon.disabled, icon: mainButtonIcon.icon, position: mainButtonIcon.position, outline: mainButtonIcon.outline, tooltip: mainButtonIcon.tooltip }));
    };
    return (_jsxs(Dropdown, { renderToggle: renderButton, placement: placement, menuStyle: menuStyle, disabled: disabled, children: [header && (_jsxs(_Fragment, { children: [_jsx(Dropdown.Item, { onClick: header.action, disabled: header.disabled, icon: header.icon, children: header.name }, "header"), _jsx(Dropdown.Separator, {})] })), dropdownButtons.map((button, index) => (_jsx(Dropdown.Item, { onClick: button.action, disabled: button.disabled, icon: button.icon, children: button.name }, index))), footer && (_jsxs(_Fragment, { children: [_jsx(Dropdown.Separator, {}), _jsx(Dropdown.Item, { onClick: footer.action, disabled: footer.disabled, icon: footer.icon, children: footer.name }, "footer")] }))] }));
}
export default DropdownButtons;
